module.exports = __webpack_public_path__ + "img/c76827b.jpg";